/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileOrFolderTypeFromJSON, FileOrFolderTypeToJSON, } from './FileOrFolderType';
import { FileAuthorFromJSON, FileAuthorToJSON, } from './FileAuthor';
/**
 * Check if a given object implements the FileOrFolder interface.
 */
export function instanceOfFileOrFolder(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function FileOrFolderFromJSON(json) {
    return FileOrFolderFromJSONTyped(json, false);
}
export function FileOrFolderFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'type': FileOrFolderTypeFromJSON(json['type']),
        'id': json['id'],
        'parentId': json['parent_id'] == null ? undefined : json['parent_id'],
        'fileKey': json['file_key'] == null ? undefined : json['file_key'],
        'sourceFormat': json['source_format'] == null ? undefined : json['source_format'],
        'processingStatus': json['processing_status'] == null ? undefined : json['processing_status'],
        'processingFailureReason': json['processing_failure_reason'] == null ? undefined : json['processing_failure_reason'],
        'childCount': json['child_count'] == null ? undefined : json['child_count'],
        'uploadedAt': json['uploaded_at'] == null ? undefined : (new Date(json['uploaded_at'])),
        'uploader': json['uploader'] == null ? undefined : FileAuthorFromJSON(json['uploader']),
        'modifiedAt': json['modified_at'] == null ? undefined : (new Date(json['modified_at'])),
        'modifier': json['modifier'] == null ? undefined : FileAuthorFromJSON(json['modifier']),
        'size': json['size'] == null ? undefined : json['size'],
    };
}
export function FileOrFolderToJSON(json) {
    return FileOrFolderToJSONTyped(json, false);
}
export function FileOrFolderToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'type': FileOrFolderTypeToJSON(value['type']),
        'id': value['id'],
        'parent_id': value['parentId'],
        'file_key': value['fileKey'],
        'source_format': value['sourceFormat'],
        'processing_status': value['processingStatus'],
        'processing_failure_reason': value['processingFailureReason'],
        'child_count': value['childCount'],
        'uploaded_at': value['uploadedAt'] == null ? undefined : (value['uploadedAt'].toISOString()),
        'uploader': FileAuthorToJSON(value['uploader']),
        'modified_at': value['modifiedAt'] == null ? undefined : (value['modifiedAt'].toISOString()),
        'modifier': FileAuthorToJSON(value['modifier']),
        'size': value['size'],
    };
}
